import { ControllerFontType } from '@bymason-private/controller-v1-theme-provider';
import { RouterButton } from '@bymason-private/route-provider';
import { Button, Text } from '@bymason-private/legacy-pattern-components';
import { routes } from '../../../router';
import { ControllerLogo } from '../controller-logo';

export default function SignUpSuccess({ invitedSignUp }: SignupSuccess) {
  return (
    <>
      <ControllerLogo />
      {invitedSignUp ? (
        <>
          <Text variant={ControllerFontType.Body400R} component='div' textAlign='center'>
            <strong>Your account has been created!</strong>
          </Text>
          <Text variant={ControllerFontType.Body400R} component='div' textAlign='center'>
            <span>Let&#39;s start building</span>
          </Text>
          <RouterButton
            buttonComponent={
              <Button size='large' fullWidth variant='contained'>
                Go to the login page
              </Button>
            }
            route={routes.Login}
          />
        </>
      ) : (
        <>
          <Text variant={ControllerFontType.Body400R} component='div' textAlign='center'>
            <strong>Thank you for signing up!</strong>
          </Text>
          <Text variant={ControllerFontType.Body400R} component='div' textAlign='center'>
            <span>Please check your email for a verification link to complete the registration process</span>
          </Text>
        </>
      )}
    </>
  );
}

interface SignupSuccess {
  invitedSignUp: boolean;
}
